<ion-content>
  <div class="tempo">
    <div style="width: 75%; display: flex; align-items: center; justify-content: center; flex-direction: column; margin-bottom: 32px;">
      <img style="width: 50px;" src="../../../assets/icon/icon.png" />
      <ion-label class="title" color="primary">Tempo</ion-label>
    </div>


    <div *ngIf="loginType==0" style="width: 100%; display: flex; align-items: center; justify-content: center; flex-direction: column;">
      <ion-label class="subtitle" color="tertiary">Scegli come accedere</ion-label>
      <ion-button *ngIf="api.isiOS()" [disabled]="signin" (click)="signinWithApple()"
        style="--background: #000000; color: rgb(227, 227, 227);" size="large">
        <ion-icon slot="start" name="logo-apple"></ion-icon>
        <ion-label>ACCEDI CON APPLE</ion-label>
      </ion-button>
      <ion-button color="google" [disabled]="signin" (click)="signinWithGoogle()" size="large">
        <ion-icon color="white" slot="start" name="logo-google"></ion-icon>
        <ion-label color="white">ACCEDI CON GOOGLE</ion-label>
      </ion-button>
      <ion-button fill="clear" (click)="loginType = 1" size="large">
        <ion-icon slot="start" name="mail"></ion-icon>
        <ion-label>ACCEDI CON E-MAIL</ion-label>
      </ion-button>
    </div>

    <div *ngIf="loginType==1" style="width: 100%; display: flex; align-items: center; justify-content: center; flex-direction: column;">
      <ion-label class="subtitle" color="tertiary">Accedi con e-mail e password</ion-label>
      <div style="width: 75%">
        <ion-input [(ngModel)]="ec.email" label="E-mail" labelPlacement="floating" inputmode="email" pattern="email" type="email">
        </ion-input>
        <ion-input [(ngModel)]="ec.pass" inputmode="text" label="Password" labelPlacement="floating" type="password">
        </ion-input>
      </div>

      <ion-button style="margin-top: 16px;" (click)="sendPasswordResetEmail()" size="small" fill="clear" class="ion-float-right">Password dimenticata?</ion-button>
      <ion-button style="margin-top: 32px;" (click)="signinWithEmail()" size="large">
        <ion-icon slot="start" name="mail"></ion-icon>
        <ion-label>ENTRA</ion-label>
      </ion-button>
      <ion-button fill="clear" (click)="loginType = 2" size="large">
        <ion-label>CREA EMAIL ACCOUNT</ion-label>
      </ion-button>
      <ion-button fill="clear" (click)="loginType = 0" size="large">
        <ion-label>INDIETRO</ion-label>
      </ion-button>
    </div>

    <div *ngIf="loginType==2" style="width: 100%; display: flex; align-items: center; justify-content: center; flex-direction: column;">
      
      <ion-label class="subtitle" color="tertiary">Crea un account con e-mail e password</ion-label>
      <div style="width: 75%">
        <ion-input type="email" label="Email" fill="solid" [pattern]="emailPattern" labelPlacement="floating" errorText="Email non valida" helperText="Inserisci una mail valida" [(ngModel)]="suec.email">
        </ion-input>
        <ion-input type="password" label="Password" [pattern]="passwordPattern" labelPlacement="floating" errorText="Deve contenere almeno una lettera maiuscola, un numero, un carattere speciale ed essere lunga almeno 8 caratteri" helperText="Scegli una password" [(ngModel)]="suec.pass">
        </ion-input>
        <ion-input type="password" label="Ripeti password" labelPlacement="floating" errorText="Le password non coincidono" helperText="Ripeti la password scelta" [(ngModel)]="suec.rpass">
        </ion-input>
        
      </div>

      <ion-button [disabled]="!isValidEmail() || !isValidPassword() || signin" style="margin-top: 16px;" (click)="signupWithEmail()" size="large">
        <ion-icon slot="start" name="mail"></ion-icon>
        <ion-label>CREA ACCOUNT</ion-label>
      </ion-button>
      <ion-button fill="clear" (click)="loginType = 1" size="large">
        <ion-label>HO GIA' UN ACCOUNT</ion-label>
      </ion-button>
      
    </div>
    

  </div>
  
</ion-content>